import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { AppSessionService } from "../app-session/app-session.service";

import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { setAdvancedFilterQuery, setSimpleFilterQuery } from "../../utils/tableUtils";
import { GridUtils } from "../../utils/gridUtils";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class CurrentAccountsService {
  constructor(private http: HttpClient, private appSession: AppSessionService) {}

  private CURRENT_ACCOUNTS_URL = this.appSession.baseUrl + "/api/v1/currentAccounts";

  getCurrentAccountsList(paging?: any, filteringArgs?: any, sortingArgs?: any, advancedFilteringArgs?: any) {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0 ? FilterOperation.AND : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    const url = paging ? this.buildDataUrl(paging, "/search?") : `${this.CURRENT_ACCOUNTS_URL}/search`;

    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  getCurrentAccountDetail(token: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.CURRENT_ACCOUNTS_URL}/${token}`;
    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  getCurrentAccountMovements(paging?: any, filteringArgs?: any, sortingArgs?: any, advancedFilteringArgs?: any) {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0 ? FilterOperation.AND : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    const url = paging
      ? this.buildDataUrl(paging, "/movements/search?")
      : `${this.CURRENT_ACCOUNTS_URL}/movements/search`;

    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  getCurrentAccountsByParty(
    token: string,
  ) {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.CURRENT_ACCOUNTS_URL}/byParty/${token}`;
    
    if (token) {
      return this.http.get<any>(url, { headers }).pipe(
        map(({ result }) => result),
        catchError((error) => throwError(error))
      );
    }
  }

  //Grid filter helpers block
  private buildDataUrl(pagingArgs: any, path: string): string {
    let baseQueryString = `${this.CURRENT_ACCOUNTS_URL}${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query += scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;
    baseQueryString += query;

    return baseQueryString;
  }
}
